<template>
  <SectionShell
    :icon="meta.icon || 'tags'"
    :label="meta.label || fieldKey"
    :count="fieldSlot.values.size"
    :total="total"
    :open="open"
    @toggle="open = $event"
  >
    <FacetRows :facet="facet" :field-slot="fieldSlot" :field-key="fieldKey" :meta="meta" :search="search" />
  </SectionShell>
</template>

<script setup>
// Enum / facet-flagged string field section. Ported from fql-search.jsx
// FacetSection.
import { ref, computed } from 'vue'
import { useFacetValues } from '@/admin-collection-layout/composables/useStructuredSearch.js'
import SectionShell from './SectionShell.vue'
import FacetRows from './FacetRows.vue'

// SearchSidebar hands every section the same prop bag. This one reads no decl,
// and `inheritAttrs: false` keeps the undeclared binding off SectionShell's
// root element rather than letting it render there as an attribute.
defineOptions({ name: 'FacetSection', inheritAttrs: false })

const props = defineProps({
  fieldKey: { type: String, required: true },
  fieldSlot: { type: Object, required: true },
  meta: { type: Object, default: () => ({}) },
  search: { type: Object, required: true },
  facetProvider: { type: Function, default: null },
  debounceMs: { type: Number, default: 220 },
})

const open = ref(false)
const facet = useFacetValues({
  field: () => props.fieldKey,
  query: () => props.search.query,
  facetProvider: props.facetProvider,
  enabled: () => open.value,
  debounceMs: () => props.debounceMs,
})
const total = computed(() => {
  if (facet.status !== 'ready' && facet.status !== 'loading') return null
  const s = new Set(facet.values.map((o) => o.value))
  props.fieldSlot.values.forEach((v) => s.add(v))
  return s.size
})
</script>
